import VueRouter from 'vue-router';
import About from './pages/About/about.vue';
import Home from './pages/Home/home.vue';
import NotFound from './shared/NotFound/not.found.vue';
import ShowingsPage from './pages/ShowingsPage/showings.page.vue';
import ListingsPage from './pages/ListingsPage/listings.page.vue';
import ReportsPage from './pages/ReportsPage/reports.page.vue';
import Skittles from './pages/SkittlesPage/skittles.page.vue';
import LoginPage from './pages/LoginPage/login.page.vue';
import PreSalePage from './pages/PreSalePage/presale.page.vue';
import PreSaleDetailPage from './pages/PreSaleDetailPage/presale.detail.page.vue';
import PreSaleStagePage from './pages/PreSaleStagePage/presale.stage.page.vue';
import RifoExlusivePage from './pages/RifoExlusivePage/rifo.exlusive.page.vue';
import RifoExlusiveStagePage from './pages/RifoExlusiveStagePage/rifo.exlusive.stage.page.vue';
import FrontstoreSettingPage from './pages/FrontStoreSettingPage/frontstore.setting.page.vue';
import ListingPresentationPage from './pages/ListingPresentation/listing.presentation.page.vue';
import LPCreatePage from './pages/LPCreatePage/l.p.create.page.vue';
import { HybridRoutes } from './routes/hybrid.routes';

export namespace RadarRouter {
    export function routerFactory(): VueRouter {
        return new VueRouter({
            routes: [
                { path: '/', component: Skittles },
                { path: '/home', component: Home },
                { path: '/about', component: About },
                { path: '/showings', component: ShowingsPage },
                { path: '/listings', component: ListingsPage },
                { path: '/reports', component: ReportsPage },
                { path: '/skittles', component: Skittles },
                { path: '/login', component: LoginPage },
                { path: '/presales', component: PreSalePage },
                { path: '/presale/:id', component: PreSaleDetailPage },
                { path: '/presales/stage/:id', component: PreSaleStagePage },
                { path: '/rifo/exlusives', component: RifoExlusivePage },
                { path: '/rifo/exlusives/stage/:id', component: RifoExlusiveStagePage },
                { path: '/frontstore/setting', component: FrontstoreSettingPage },
                { path: '/listing-presentation/lists', component: ListingPresentationPage },
                { path: '/listing-presentation/stage', component: LPCreatePage },
                { path: '/listing-presentation/stage/:id', component: LPCreatePage },
                ...HybridRoutes.factory(),
                {
                    path: '*',
                    component: NotFound,
                },
            ],
            scrollBehavior(to, from, savedPosition) {
                return { x: 0, y: 0 };
            }
        });
    }
}
